import React from "react";
import { makeStyles, CircularProgress } from "@material-ui/core";
import ErrorIcon from "@material-ui/icons/ErrorOutline";
import CheckIcon from "@material-ui/icons/Check";
import InfoIcon from "@material-ui/icons/InfoOutlined";
export var StatusChip = function (_a) {
    var title = _a.title, message = _a.message, _b = _a.type, type = _b === void 0 ? "info" : _b, retry = _a.retry, link = _a.link, style = _a.style, _c = _a["data-cy"], dataCy = _c === void 0 ? "StatusChip" : _c;
    var useStyles = makeStyles(function (theme) { return ({
        root: {
            display: "flex",
            alignItems: "center",
            borderRadius: 4,
            color: type === "loading"
                ? theme.palette.primary.dark
                : theme.palette[type].contrastText,
            background: type === "loading"
                ? theme.palette.grey["200"]
                : theme.palette[type].main,
            padding: theme.spacing(1, 1),
            animation: "$popIn .3s ease-in-out",
            "& a": {
                color: "inherit",
                textDecoration: "underline"
            }
        },
        icon: {},
        message: {
            paddingLeft: theme.spacing(1) + "px"
        },
        title: {
            fontSize: 16,
            fontWeight: "bold",
            marginBottom: 5
        },
        retry: {
            marginLeft: 10,
            color: "inherit",
            fontWeight: "bold",
            textDecoration: "underline",
            cursor: "pointer"
        },
        "@keyframes popIn": {
            "0%": {
                transform: "scale(0.8)"
            },
            "100%": {
                transform: "scale(1)"
            }
        }
    }); });
    var classes = useStyles();
    if (message || title) {
        if (typeof message !== "string" && !React.isValidElement(message)) {
            // Don't blow up if a JS object has been passed by mistake. eg. a weird DC error response.
            message = JSON.stringify(message);
        }
        return (React.createElement("div", { className: classes.root, "data-cy": dataCy, style: style },
            React.createElement("div", { className: classes.icon },
                type === "loading" && React.createElement(CircularProgress, { color: "inherit" }),
                type === "error" && (React.createElement(ErrorIcon, { style: { width: 30, height: 30 }, color: "inherit" })),
                type === "success" && (React.createElement(CheckIcon, { style: { width: 30, height: 30 }, color: "inherit" })),
                type === "info" && (React.createElement(InfoIcon, { style: { width: 30, height: 30 }, color: "inherit" }))),
            React.createElement("div", { className: classes.message },
                title && React.createElement("div", { className: classes.title }, title),
                message,
                retry && (React.createElement("span", { className: classes.retry, onClick: retry }, "Please try again")),
                link && link)));
    }
    return React.createElement("div", null);
};
StatusChip.displayName = "StatusChip";
//# sourceMappingURL=StatusChip.js.map